module.exports = __webpack_public_path__ + "static/media/7.be8ddf8b.jpg";